module.exports = __webpack_public_path__ + "static/img/ability3.6382bdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ability3.png
// module id = YOLe
// module chunks = 0